import { Flex, Switch, Typography } from "antd"

type Props = {
  checked: boolean
  label: string
  description: string
  onClick: () => void
  disabled?: boolean
}

const SwitchWithDescription = ({ checked, label, description, onClick, disabled }: Props) => {
  const handleClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  return <Flex gap={8} align="top">
    <Switch checked={checked} onClick={handleClick} disabled={disabled} />
    <div>
      <strong style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} onClick={handleClick}>{label}</strong>
      <br/>
      <Typography.Text type="secondary">{description}</Typography.Text>
    </div>
  </Flex>
}

export default SwitchWithDescription